import React from "react";

export const HomeLayout1 = ({ header, content, image }) => {
  return (
    <div className="grid grid-cols-2 items-center pb-32">
      <div className="w-4/6 -mb-20">
        <h1 className="pb-3">{header}</h1>
        <p>{content}</p>
      </div>
      <div className="group justify-self-end">
        <div className="w-72 h-[25rem] border-4 border-secondary relative group-hover:translate-x-2 group-hover:-translate-y-2 transition-all delay-150">
          <div className="h-[25rem] w-[20rem] top-10 right-10 absolute group-hover:top-16 group-hover:right-16 transition-all delay-150">
            <img
              src={image}
              alt=""
              className="h-full w-full object-cover scale-110"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeLayout2 = ({ header, content, image }) => {
  return (
    <div className="grid grid-cols-2 items-center py-4 h-[40rem]">
      <div className="group -mb-40">
        <div className="w-72 h-[18rem] border-4 border-secondary relative group-hover:-translate-x-2 group-hover:translate-y-2 transition-all delay-150">
          <div className="h-[25rem] w-[20rem] bottom-10 left-10 absolute group-hover:bottom-16 group-hover:left-16 transition-all delay-150">
            <img
              src={image}
              alt=""
              className="h-full w-full object-cover scale-110"
            />
          </div>
        </div>
      </div>
      <div className="w-4/6 justify-self-end">
        <h1 className="pb-3">{header}</h1>
        <p>{content}</p>
      </div>
    </div>
  );
};
